import { ApiProperty } from "@nestjs/swagger";

export class VehicleReqId {
    @ApiProperty()
    reqId: number;
}